import {ChangeEventHandler, useEffect, useState} from 'react';
import {ChangeHandler} from '../../types/Handler';

export type ToggleProps = {
    id: string,
    className?: string,
    value: boolean,
    labelLeft?: string,
    labelRight?: string,
    onChange?: ChangeHandler,
}

const Toggle = (props: ToggleProps) => {
    const [value, setValue] = useState(props.value);

    useEffect(() => {
        setValue(props.value);
    }, [props.value]);

    const onChange: ChangeEventHandler<HTMLInputElement> = (evt) => {
        setValue(evt.target.checked);
        if (props.onChange) {
            props.onChange(props.id, evt.target.checked);
        }
    };
    return (
        <div className={`dfb-dfb-Toggle${props.className ? props.className : ''}`}>
            <label className="dfb-Toggle-field">
                <span className="dfb-Toggle-labelUnchecked">{props.labelLeft ? props.labelLeft : 'Off'}</span>
                <input className="dfb-Toggle-input"
                       type="checkbox"
                       onChange={onChange}
                       defaultChecked={value}
                       name="checkbox"/>
                <span className="dfb-Toggle-box" aria-hidden="true"></span>
                <span className="dfb-Toggle-labelChecked">{props.labelRight ? props.labelRight : 'On'}</span>
            </label>
        </div>
    );
};

Toggle.defaultProps = {
    className: '',
    value: false
};

export default Toggle;
